const firstState = {
  data: JSON.parse(window.localStorage.getItem('user')) || '',
  loggedIn: !!window.localStorage.getItem('user')
}

const getters = {

}

const mutations = {
  loggedIn(state, payload) {
    state.loggedIn = true
    state.data = payload.user
    window.localStorage.setItem('user', JSON.stringify(payload.user))
    window.localStorage.setItem('token', payload.user.token)
  },
  logout(state) {
    window.localStorage.removeItem('user')
    window.localStorage.removeItem('token')
    window.localStorage.removeItem('panel-user')
    state.loggedIn = false
    state.data = ''
  }
}
const actions = {
  login({ commit }, payload) {
    const promise = this._vm.$http.post('v2/user/login', {
      phone_number: payload.phone_number,
      country_phone_code: payload.country_phone_code,
      password: payload.password
    })

    promise.then((res) => {
      commit('loggedIn', res.data)
    })

    return promise
  },
  register({ commit }, payload) {
    const promise = this._vm.$http.post('v2/user/register', {
      phone_number: payload.phone_number,
      country_phone_code: payload.country_phone_code,
      password: payload.password,
      password_confirmation: payload.password_confirmation,
      first_name: payload.first_name,
      last_name: payload.surname,
      email: payload.email
    })

    promise.then((res) => {
      commit('loggedIn', res.data)
    })

    return promise
  }
}

export default {
  state: firstState,
  getters,
  mutations,
  actions
}
